import AuthScreen from "./auth.screen";

export default AuthScreen;